export default {
  getOperatorOptions: state => state.operatorList.map(operator => ({ value: operator.operatorId, text: operator.name })),
  getTokenOptions: state => state.tokenList.map(({ tokenId, name }) => ({ value: tokenId, text: name })),
  getTokensMap: state => state.tokenList.reduce((acc, { tokenId, name, blockchainNetwork, blockchainNetworkIconUrl }) => ({ ...(acc || {}), [tokenId]: { name, blockchainNetwork, blockchainNetworkIconUrl } }), {}),
};
